// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <circle cx="6.7" cy="12" r="4.7" />
  <circle cx="17.3" cy="12" r="4.7" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-flickr-D_Xc7aak.js.map
